import React from "react";
import { Image, MapPin, TrendingUp } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRandomTargetData } from "./useRandomTargetData";
import ImageTargetPreview from "./ImageTargetPreview";
import LocationTargetPreview from "./LocationTargetPreview";
import PredictionTargetPreview from "./PredictionTargetPreview";

const TargetTypesSection = () => {
  const randomData = useRandomTargetData();

  const targetTypes = [
    {
      icon: Image,
      title: "Image Targets",
      description: "Random images revealed after the session.",
      preview: <ImageTargetPreview image={randomData.image} />,
    },
    {
      icon: MapPin,
      title: "Location Targets",
      description: "Real-world places revealed post-session.",
      preview: <LocationTargetPreview location={randomData.location} />,
    },
    {
      icon: TrendingUp,
      title: "Prediction Targets",
      description: "Event outcomes tied to real, live prediction markets.",
      preview: <PredictionTargetPreview prediction={randomData.prediction} />,
    },
  ];

  return (
    <section className="py-24">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
            Target Types
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Each session starts blind. You only see the target after you've recorded your impressions.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {targetTypes.map((target) => (
            <Card key={target.title} className="bg-card/50 border-border/50 hover:border-border transition-colors overflow-hidden">
              <CardHeader className="flex flex-row items-center gap-4 pb-2">
                <div className="p-2 rounded-lg bg-primary/10">
                  <target.icon className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <CardTitle className="text-xl">{target.title}</CardTitle>
                  <span className="text-xs text-muted-foreground/70">Example</span>
                </div>
              </CardHeader>
              <CardContent className="space-y-4">
                <CardDescription className="text-base text-muted-foreground">
                  {target.description}
                </CardDescription>
                {target.preview}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetTypesSection;
